import vueAwesomeCountdown from "vue-awesome-countdown";
import * as types from "@/store/types";
import { mapGetters, mapActions } from "vuex";
import VueHtml2pdf from "vue-html2pdf";
import dayjs from "dayjs";
import $thousandMask from "@/mixins/thousandMask";
import { OperationService } from "@/services";
const OtpOrder = () => import("@/components/Shared/OtpOrder/index");

export default {
  name: "sell",
  components: { vueAwesomeCountdown, VueHtml2pdf, OtpOrder },
  mixins: [$thousandMask],
  props: [],
  filters: {
    dateTimeFilter(date) {
      return (
        dayjs(date).format("HH:mm") + " - " + dayjs(date).format("YYYY/MM/DD")
      );
    }
  },
  data() {
    return {
      processStep: {},
      defaultProcessStep: {
        id: "",
        status: "",
        step: ""
      },
      phoneNumber: "",
      otpCode: "",
      orderData: {},
      toggleMethod: false,
      value: 100,
      interval: {},
      confirmLoading: false,
      expiredOtpTimestamp: 0,
      isCounterExpired: false,
      countdownTimer: "",
      clockInterval: "",
      counterTime: 0,
      copyFlag: true
    };
  },
  computed: {
    ...mapGetters({
      getProcessingOrder: types.operations.getters.GET_PROCESSING_ORDER,
      getOrderStep: types.operations.getters.GET_ORDER_STEP,
      getUserInfo: types.userInfo.getters.GET_USER_INFO,
      getCountDownStatus: types.operations.getters.GET_COUNTDOWN_STATUS
    }),
    isCountDownReset() {
      return this.getCountDownStatus;
    },
    processingOrderData() {
      if (this.getProcessingOrder) {
        return this.getProcessingOrder;
      }
    },
    userInfo() {
      return this.getUserInfo;
    },
    fiatOrderStep() {
      if (Object.entries(this.getOrderStep).length !== 0) {
        return this.getOrderStep.fiat.sell;
      }
    },
    orderTransactionId() {
      return this.$route.params.id;
    }
  },
  watch: {
    orderTransactionId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getOrderData();
        }
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.$refs.orderCountDown.stopCountdown();
    clearInterval(this.clockInterval);
    Object.assign(this.processStep, this.defaultProcessStep);
    this.setOrderExpiration(false);
  },
  mounted() {
    this.resetTime();
    this.getOrderData();
  },
  methods: {
    ...mapActions({
      setOrderExpiration:
        types.operations.actions.ACTION_ORDER_EXPIRATION_STATUS,
      setProcessingOrder: types.operations.actions.ACTION_PROCESSING_ORDER,
      cancelOrderStep: types.operations.actions.ACTION_CANCEL_ORDER_STEP,
      setCountDownStatus: types.operations.actions.ACTION_COUNTDOWN_STATUS
    }),
    resetTime() {
      this.interval = setInterval(() => {
        if (this.value === 0) {
          return (this.value = 100);
        }
        this.value = parseInt(100 - (this.nowTime / this.fixTime) * 100);
        this.nowTime += 1000;
      }, 1000);
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    confirmOrder() {
      this.$refs.orderCountDown.stopCountdown();
      let data = {
        ref_no: this.orderTransactionId
      };
      OperationService.confirmOrder(data)
        .then(response => {
          window.location.replace(response.data.data.url);
          // this.getOrderData();
        })
        .catch(() => {
          this.getOrderData();
        });
    },
    onExpiredTime() {
      if (this.processStep.step === "confirm") {
        this.setOrderExpiration(true);
        this.$refs.orderCountDown.stopCountdown();
        clearInterval(this.interval);
        this.cancelOrderStep(3);
      }
    },
    verifyOtp() {
      let data = {
        ref_no: this.orderTransactionId,
        verification_code: this.otpCode
      };
      OperationService.verifyOrderOtp(data).then(() => {
        this.getOrderData();
      });
    },
    createOrderTransactionId() {
      if (this.copyFlag) {
        this.copyFlag = false;
        this.$toast.success(this.$t("orderProcessPage.txNumberCopied"));
      } else {
        setTimeout(() => {
          this.copyFlag = true;
        }, 3000);
      }
    },
    getOrderData() {
      this.confirmLoading = true;
      OperationService.showOrder(this.orderTransactionId)
        .then(response => {
          this.nowTime = parseInt(
            response.data.time - response.data.data.created_at
          );
          this.fixTime = parseInt(
            response.data.data.expires_in - response.data.data.created_at
          );
          this.counterTime = parseInt(
            response.data.data.expires_in - response.data.time
          );
          this.expiredOtpTimestamp = response.data.data.sms_expires_in;
          this.isCounterExpired = false;
          this.countdown(this.expiredOtpTimestamp);
          this.setProcessingOrder(response.data.data);
          let activeStep = {
            step: response.data.data.step,
            status: response.data.data.status
          };
          if (response.data.data.status === "EXPIRED") {
            this.$router.push({
              path: "/fiat"
            });
          }
          let refNo = this.$route.params.id;
          OperationService.getOrderConfig(refNo).then(response => {
            response.data.data.step.fiat.sell.forEach(elem => {
              if (elem.step === activeStep.step) {
                this.processStep = {
                  id: elem.id,
                  status: activeStep.status,
                  step: elem.step
                };
                if (this.processStep.id === 2) {
                  this.cancelOrderStep(3);
                } else {
                  this.cancelOrderStep(this.processStep.id);
                }
              }
            });
          });
          if (this.isCountDownReset) {
            this.$refs.orderCountDown.startCountdown(true);
            this.value = 100;
            this.time = 0;
            clearInterval(this.interval);
            this.resetTime();
          }
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    },
    resendSms() {
      let data = {
        ref_no: this.orderTransactionId
      };
      OperationService.resendOrderVerification(data)
        .then(() => {
          this.getOrderData();
        })
        .catch(() => {
          this.getOrderData();
        });
    },
    countdown(distance) {
      distance = distance / 1000;
      this.clockInterval = setInterval(() => {
        distance--;
        let minutes = Math.floor(distance / 60);
        let seconds = Math.floor(distance % 60);
        if (minutes < 10) {
          minutes = "0" + minutes;
        }
        if (seconds < 10) {
          seconds = "0" + seconds;
        }
        let x = minutes + ":" + seconds;
        if (distance < 0) {
          this.countdownTimer = "00:00";
          this.isCounterExpired = true;
          clearInterval(this.clockInterval);
        } else {
          this.countdownTimer = x;
        }
      }, 1000);
    }
  }
};
